module.exports = __webpack_public_path__ + "static/img/icon-02.22b33f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/how-it-works/icon-02.png
// module id = /pWW
// module chunks = 1